(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[261,648,4346,682],{

/***/ 4346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./src/components/shared/breadCrumb/styles/styles.module.scss
var styles_module = __webpack_require__(6962);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/assets/breadCrumb.avif
/* harmony default export */ var breadCrumb = ({"src":"/_next/static/media/breadCrumb.aff9d432.avif","height":1330,"width":2000,"blurDataURL":"data:image/avif;base64,AAAAHGZ0eXBhdmlmAAAAAG1pZjFhdmlmbWlhZgAAAXBtZXRhAAAAAAAAACFoZGxyAAAAAAAAAABwaWN0AAAAAAAAAAAAAAAAAAAAAA5waXRtAAAAAAABAAAANGlsb2MAAAAAREAAAgABAAAAAAGUAAEAAAAAAAAATwACAAAAAAHjAAEAAAAAAAAAFQAAADhpaW5mAAAAAAACAAAAFWluZmUCAAAAAAEAAGF2MDEAAAAAFWluZmUCAAAAAAIAAGF2MDEAAAAAr2lwcnAAAACKaXBjbwAAAAxhdjFDgSACAAAAABRpc3BlAAAAAAAAAAgAAAAFAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAcAAAAAA5waXhpAAAAAAEIAAAAOGF1eEMAAAAAdXJuOm1wZWc6bXBlZ0I6Y2ljcDpzeXN0ZW1zOmF1eGlsaWFyeTphbHBoYQAAAAAdaXBtYQAAAAAAAAACAAEDgQIDAAIEhAIFhgAAABppcmVmAAAAAAAAAA5hdXhsAAIAAQABAAAAbG1kYXQSAAoIOAi8YQENBpAyQRTAAABQqEVlZka/Msh/reC4VnUKNzTWMxH5mLGkhcrFORQnQ2II1O05fqzWbykXkMdGLA/rXmxorUD2MsXhlSGAEgAKBRgIvGFQMgoUwAABAAF1UKUo","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/assets/works_breadcrumb.jpg
/* harmony default export */ var works_breadcrumb = ({"src":"/_next/static/media/works_breadcrumb.537d82bb.jpg","height":200,"width":1700,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAABAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAYEAEAAwEAAAAAAAAAAAAAAAAAAQIzcf/EABUBAQEAAAAAAAAAAAAAAAAAAAME/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAIxAf/aAAwDAQACEQMRAD8AhYwtwA7UnWYf/9k=","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/assets/servics_breadcrumb.jpg
/* harmony default export */ var servics_breadcrumb = ({"src":"/_next/static/media/servics_breadcrumb.406428d8.jpg","height":200,"width":1700,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAABAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAZEAEAAgMAAAAAAAAAAAAAAAAAAgMzcsL/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhEDEQA/AIivNHToAkHX/9k=","blurWidth":8,"blurHeight":1});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/Index.js












var BreadCrumb = function BreadCrumb(_ref) {
  var title = _ref.title;
  var router = (0,next_router.useRouter)();
  var locale = router.locale;
  var isRtl = locale === "ar";
  var isServicesPage = router.pathname === "/services";
  var isWorksPage = router.pathname === "/ourworks" || router.pathname === "/blogs" || router.pathname === "/blogs/[slug]";
  var backgroundImage = isServicesPage ? servics_breadcrumb : isWorksPage ? works_breadcrumb : breadCrumb;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (styles_module_default()).breads,
    dir: locale === "ar" ? "rtl" : "ltr",
    style: {
      backgroundImage: "url(".concat(backgroundImage.src || backgroundImage, ")")
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container["default"], {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).breads__inner,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (styles_module_default()).breads__content,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/contactus",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: (styles_module_default())["cta-button-red"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "contact-us"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["icon-circle"],
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                  style: {
                    transform: isRtl ? "none" : "scaleX(-1)"
                  },
                  width: "18",
                  height: "18",
                  viewBox: "0 0 18 18",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    d: "M3.53577 3.53556L14.1424 14.1422",
                    stroke: "black",
                    strokeWidth: 1.5,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                    stroke: "black",
                    strokeWidth: 1.5,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  })]
                })
              })]
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ var Index = (BreadCrumb);

/***/ }),

/***/ 261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _PoliciesPage_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1681);
/* harmony import */ var _PoliciesPage_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_PoliciesPage_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var src_components_shared_breadCrumb_Index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4346);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4012);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(682);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);










var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(646), __webpack_require__.e(1608), __webpack_require__.e(7148), __webpack_require__.e(7216)]).then(__webpack_require__.bind(__webpack_require__, 7148));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7148)];
    }
  }
});
var PageHeader = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(646), __webpack_require__.e(1608), __webpack_require__.e(9477), __webpack_require__.e(4208), __webpack_require__.e(1824)]).then(__webpack_require__.bind(__webpack_require__, 2094));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(2094)];
    }
  }
});

var PoliciesPage = function PoliciesPage(_ref) {
  var _data$title, _data$content;

  var data = _ref.data,
      footerSettings = _ref.footerSettings;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      lang = _useRouter.locale;

  var title = data === null || data === void 0 ? void 0 : (_data$title = data.title) === null || _data$title === void 0 ? void 0 : _data$title[lang];
  var content = data === null || data === void 0 ? void 0 : (_data$content = data.content) === null || _data$content === void 0 ? void 0 : _data$content[lang];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(PageHeader, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_shared_breadCrumb_Index__WEBPACK_IMPORTED_MODULE_3__["default"], {
      title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        id: "policies"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__["default"], {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: (_PoliciesPage_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content),
        children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("h1", {
          children: title
        }), content && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: (_PoliciesPage_module_scss__WEBPACK_IMPORTED_MODULE_7___default().contentText),
          dangerouslySetInnerHTML: {
            __html: content
          }
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Footer, {
      footerLinks: footerSettings
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (PoliciesPage);

/***/ }),

/***/ 6962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breads":"styles_breads__eY1Zd","breads__inner":"styles_breads__inner__WYN36","breads__content":"styles_breads__content__i7wfq","cta-button-red":"styles_cta-button-red__Oa5fB","icon-circle":"styles_icon-circle__VDLuX"};

/***/ }),

/***/ 1681:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"PoliciesPage_content__lKFjF","contentText":"PoliciesPage_contentText__8P_DX"};

/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["default"] = (Container);

/***/ }),

/***/ 4012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _useIntl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */




function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(prevProps, ["values"]);
    var nextValues = nextProps.values, nextOtherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(nextProps, ["values"]);
    return ((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(nextValues, values) &&
        (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(otherProps, nextOtherProps));
}
function FormattedMessage(props) {
    var intl = (0,_useIntl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? react__WEBPACK_IMPORTED_MODULE_0__.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag,
    });
    if (typeof children === 'function') {
        return children(Array.isArray(nodes) ? nodes : [nodes]);
    }
    if (Component) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(nodes));
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes);
}
FormattedMessage.displayName = 'FormattedMessage';
var MemoizedFormattedMessage = react__WEBPACK_IMPORTED_MODULE_0__.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
/* harmony default export */ __webpack_exports__["Z"] = (MemoizedFormattedMessage);


/***/ }),

/***/ 6896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _injectIntl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4806);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);



function useIntl() {
    var intl = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_injectIntl__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._y);
    (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .invariantIntlContext */ .lq)(intl);
    return intl;
}


/***/ })

}]);